import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const RECOMMEND_MENU: PermissionTableRowType = {
  name: '추천',
  key: 'RECOMMEND_MANAGE',
  subRows: [
    {
      name: '상품 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상품 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '상품 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
    {
      name: '상품 후기 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT_REVIEW,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT_REVIEW,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상품 후기 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT_REVIEW,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '상품 후기 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_PRODUCT_REVIEW,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
    {
      name: '태그 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_TAG,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_TAG,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '태그 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_TAG,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '태그 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_TAG,
          permissions: ['create'],
        },
      ],
    },
    {
      name: '검색 키워드 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_SEARCH,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_SEARCH,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '검색 키워드 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_SEARCH,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '검색 키워드 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_SEARCH,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
    {
      name: '기획전 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_EVENT,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_EVENT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '기획전 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_EVENT,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '기획전 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_EVENT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
    {
      name: '브랜드 추천',
      key: PERMISSION_SUBJECTS.RECOMMEND_STORE,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_STORE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '브랜드 추천 상세 조회',
          key: PERMISSION_SUBJECTS.RECOMMEND_STORE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '브랜드 추천 등록',
          key: PERMISSION_SUBJECTS.RECOMMEND_STORE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
  ],
};
